import React from 'react';
import Header from '../Header';
import Hero from '../Hero';
import About from '../About';
import Services from '../Services';
import Projects from '../Projects';
import FAQ from '../FAQ';
import Contact from '../Contact';
import Footer from '../Footer';
import SEOHead from '../seo/SEOHead';
import { LocalBusinessSchema, WebSiteSchema, FAQSchema } from '../seo/SchemaMarkup';
import { PAGE_SEO } from '../../seoConfig';
import { faqs } from '../../mockData';

const HomePage = () => {
  return (
    <>
      <SEOHead 
        title={PAGE_SEO.home.title}
        description={PAGE_SEO.home.description}
        canonical={PAGE_SEO.home.canonical}
      />
      <LocalBusinessSchema />
      <WebSiteSchema />
      <FAQSchema faqs={faqs} />
      
      <Header />
      <Hero />
      <About />
      <Services />
      <Projects />
      <FAQ />
      <Contact />
      <Footer />
    </>
  );
};

export default HomePage;
